// extracted by mini-css-extract-plugin
module.exports = {"panelHeader":"PuzzleBoard_panelHeader__4d_tj","heartLost":"PuzzleBoard_heartLost__2CNc9","heart-lost":"PuzzleBoard_heart-lost__IWu2z"};